"use client";

import React from "react";
import { Shield, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function VisionPhilosophie() {
  return <section data-section-id="264289" id="vision-philosophie" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="bg-card rounded-lg shadow-md overflow-hidden border border-border">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            
            <div className="p-8 md:p-12 lg:p-16 xl:p-20 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 mb-6">
                <span className="h-px w-8 bg-primary"></span>
                <h2 className="text-primary font-semibold tracking-widest uppercase text-sm font-default">
                  Vision und Fundament
                </h2>
              </div>

              <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-6 leading-tight">
                Ein Raum für Ihre Selbstermächtigung.
              </h3>

              <div className="space-y-6 text-muted-foreground text-lg leading-relaxed mb-10 font-default">
                <p>
                  Wir haben ein Zentrum geschaffen, an dem verschiedene Fachbereiche – psychologische Praxis,
                  systemische Organisationsberatung, traditionelle Bewegungskunst und Naturpädagogik – organisch
                  ineinandergreifen. Unsere Vision is es, Ihnen wirksame Wege und Werkzeuge an die Hand zu geben, mit
                  denen Sie Ihr Wohlbefinden selbst gestalten.
                </p>
                <p>
                  Nach unserer Philosophie sieht echte Unterstützung so aus, dass sie Sie immer in Ihre eigene Kraft
                  führt. Professionelle Helfer und Institutionen sind in stürmischen Zeiten wichtige Begleiter – das
                  Ziel unserer Arbeit ist es jedoch, Sie zunehmend unabhängiger von externer Struktur zu machen und Ihre
                  Fähigkeit zur eigenständigen Selbstregulation nachhaltig zu stärken.
                </p>
                <p>
                  Diese gewonnene Widerstandskraft soll ausstrahlen. Indem Sie lernen, sich selbst flexibel und stabil
                  durch Krisen zu steuern, weiten Sie diese Kompetenz ganz natürlich auf Ihr persönliches, familiäres
                  und berufliches Umfeld aus. Wir glauben nicht an eine isolierte Ellbogen-Resilienz, sondern an das
                  gemeinsame Fundament für eine zukunftsfähige Welt, die an gesellschaftlichen und globalen
                  Herausforderungen wächst.
                </p>
              </div>
            </div>

            <div className="relative min-h-[400px] lg:min-h-full">
              <div className="absolute inset-0 bg-primary/10 mix-blend-multiply z-10"></div>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/forest_landscape_vision.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/forest_landscape_vision.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629163/img/forest_landscape_vision.png-wvc-sizes" alt="Ruhige Waldlandschaft mit grünen Bäumen" className="absolute inset-0 w-full h-full object-cover object-center" loading="lazy" />
              <div className="absolute top-0 bottom-0 left-0 w-1 bg-primary z-20 hidden lg:block"></div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}